"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var smartimagesrc_1 = require("@ezbuy/smartimagesrc");
var styles = require("./index.scss");
var Image_1 = require("../../common/Image");
var banner_1 = require("../../utils/banner");
var prm_1 = require("utils/prm");
var WithPrm_1 = require("components/WithPrm");
var WebMagicBanner = (function (_super) {
    __extends(WebMagicBanner, _super);
    function WebMagicBanner(props) {
        var _this = _super.call(this, props) || this;
        _this.onImgLoad = function (width, height) {
            if (!_this.state.width || !_this.state.height) {
                _this.setState({
                    width: width,
                    height: height
                });
            }
        };
        _this.state = {
            width: +props.banner.width || 0,
            height: +props.banner.height || 0
        };
        return _this;
    }
    WebMagicBanner.prototype.genLinkByUrl = function (url, order) {
        var tprm = this.props.tprm;
        if (url.startsWith("#")) {
            return url;
        }
        return prm_1.genPrmLink(url, __assign(__assign({}, tprm), { position: order }));
    };
    WebMagicBanner.prototype.linkTo = function (link, order) {
        var _this = this;
        var tprm = this.props.tprm;
        var linkID = link.substr(1);
        var dom = document.getElementById(linkID);
        dom.scrollIntoView({ block: "start" });
        setTimeout(function () {
            window.scrollBy(0, -_this.props.stickToTop);
        }, 0);
        if (!link.startsWith("#")) {
            prm_1.sendPrmBylink(prm_1.genPrmLink(link, __assign(__assign({}, tprm), { position: order })));
        }
    };
    WebMagicBanner.prototype.render = function () {
        var _this = this;
        var _a = this.props, id = _a.id, positionIndex = _a.positionIndex, magicItems = _a.magicItems, tprm = _a.tprm;
        var _b = this.state, width = _b.width, height = _b.height;
        var banner = banner_1.transformBanner(this.props.banner, tprm, 0);
        var _c = banner_1.transformBannerSize({
            width: width,
            height: height
        }), realWidth = _c.width, aspectRatio = _c.aspectRatio;
        return (React.createElement("div", { id: id, className: styles.magicBanner, "data-positionid": positionIndex },
            React.createElement("div", { className: styles.banner, style: {
                    width: realWidth + "px",
                    paddingTop: aspectRatio + "%"
                } },
                React.createElement("a", { href: banner.link || undefined, target: "_blank", style: {
                        marginTop: "-" + aspectRatio + "%"
                    } },
                    React.createElement(Image_1.default, { className: styles.background, src: banner.img, defaultSrc: smartimagesrc_1.makeImageUrls(banner.img, {
                            online: true,
                            qnParams: { w: width },
                            keepSize: true,
                            aliSize: 19.2
                        })[0] || banner.img, alt: "", key: banner.img, params: "imageView2/2/" + realWidth, isLazyLoad: true, onImgLoad: this.onImgLoad })),
                magicItems &&
                    magicItems.map(function (item, index) {
                        var link = _this.genLinkByUrl(item.link, index + 1);
                        return (React.createElement("a", { key: index, href: link || null, "data-href": link, onClick: function () { return _this.linkTo(link, index + 1); }, target: item.link.startsWith("#") ? "_self" : "_blank", className: styles.clickAbleArea, style: {
                                left: item.left + "%",
                                top: item.top + "%",
                                width: item.width + "%",
                                height: item.height + "%"
                            } }));
                    }))));
    };
    return WebMagicBanner;
}(React.Component));
exports.default = WithPrm_1.default(WebMagicBanner);
